<template>
<div class="header__enter" ref="enter">
    <div class="header__enter-1"><img src="/img/list-bg-2.png" alt=""></div>
    <div class="header__enter-2"><img src="/img/list-bg-1.png" alt=""></div>
    <div class="header__enter-3"><img src="/img/arrow-spiral-3.svg" alt=""></div>
    <input type="text" placeholder="введите е-майл" class="header__input">
    <input type="submit" class="header__button" value="Войти">
</div>
</template>

<script>
export default {
    name: "header__enter",
}
</script>

<style>
.header__enter-1,
.header__enter-2,
.header__enter-3 {
    position: absolute;
}

.header__enter-1 img {
    width: 93.55px;
}

.header__enter-1 {
    top: -20px;
    left: -5px;
}

.header__enter-2 img {
    width: 150px;
}

.header__enter-2 {
    right: 0px;
    top: -15px;
}

.header__enter-3 img {
    width: 73px;
}

.header__enter-3 {
    bottom: 10%;
    left: 10%;
    transform: rotate(-50deg);
}

.header__enter {
    width: 740px;
    height: 336px;
    background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #FFFDFD;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    position: fixed;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 990;
}

.header__input {
    border: 2px solid #44AF5C;
    border-radius: 10.1575px;
    width: 500px;
    height: 60px;
    text-align: center;
    font-size: 20.315px;
    line-height: 18px;
    color: #898989;
    outline: none;
    margin: 0 auto 25px auto;
}

.header__button {
    background: linear-gradient(180deg, #04C44C 0%, #20C05C 100%);
    border-radius: 15.8034px;
    width: 176px;
    height: 60px;
    font-size: 24px;
    color: #fff;
    line-height: 28px;
    outline: none;
    border: 0;
    cursor: pointer;
    margin: 0 auto;
}

.header__input::placeholder {
    color: #898989;
    text-align: center;
    font-size: 20.315px;
    line-height: 18px;
}
</style>
